module.exports = __webpack_public_path__ + "assets/img/1_692_big.fa847bd5.jpg";